import { api } from './index'

type GrantedRewardImpactPreviewResponse = {
  rewards_count: number
}

export type GrantedRewardImpactPreview = {
  rewardsCount: number
}

export const transformGrantedRewardImpactPreview = (
  response: GrantedRewardImpactPreviewResponse
): GrantedRewardImpactPreview => ({
  rewardsCount: response.rewards_count,
})

// Relative suffix only — the `/merchants/:id` prefix is applied by the shared
// baseQuery via buildBaseUrl (see api/utils.ts), same as every other endpoint.
export const grantedRewardImpactPreviewQuery = () => ({
  url: `/granted_reward_impact_preview`,
})

export const grantedRewardExpirationApi = api.injectEndpoints({
  endpoints: builder => ({
    getGrantedRewardImpactPreview: builder.query<
      GrantedRewardImpactPreview,
      void
    >({
      query: grantedRewardImpactPreviewQuery,
      transformResponse: transformGrantedRewardImpactPreview,
      providesTags: ['GrantedRewardImpactPreview'],
    }),
  }),
})

export const { useGetGrantedRewardImpactPreviewQuery } =
  grantedRewardExpirationApi
